import { TopStatistics } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { CreateTopStatisticsModel } from './C50TopStatistics.service';
import { C50TopStatisticsProps } from './C50TopStatistics.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C50TopStatisticsProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = CreateTopStatisticsModel(props);

  return (
    <TopStatistics
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C50TopStatisticsProps>(Default);
